// extracted by mini-css-extract-plugin
export default {"emptyState":"EmptyState_emptyState__BrXGw"};